import styled from "styled-components";

export const ContainerExamsTab = styled.div``;

export const HeaderExamsTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
`;

export const DivInformationExamsTab = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  justify-content: space-between;
  margin-left: 10%;
`;
